module.exports = __webpack_public_path__ + "static/thank-you-bg-6135383392c7747c5e483b58f0f27fe9.jpg";